import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["width", "height", "viewBox"]
const _hoisted_2 = ["xlink:href"]

import { computed } from "vue";
import { BasicIcons } from "./basic-icons";


export default /*@__PURE__*/_defineComponent({
  __name: 'kasa-icon',
  props: {
    name: {},
    width: { default: 16 },
    height: { default: 16 }
  },
  setup(__props: any) {

const props = __props;

const className = computed(() => `svg-ico-${props.name}`);

const getViewBox = computed(() => {
    return `0 0 ${props.height} ${props.width}`;
});

const getName = computed(() => `/frontend/kasa-loyalty/img/icons/basic/${props.name}.svg#${props.name}`);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", {
    width: _ctx.width,
    height: _ctx.height,
    viewBox: getViewBox.value,
    class: _normalizeClass(className.value)
  }, [
    _createElementVNode("use", { "xlink:href": getName.value }, null, 8, _hoisted_2)
  ], 10, _hoisted_1))
}
}

})